import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { auth } from "../actions/auth";
import LoadingDots from "../components/ui/LoadingDots";

class Auth extends Component {
	componentDidMount() {
		this.props.authAction();
	}

	render() {
		return <LoadingDots show={typeof this.props.loaders.auth !== "undefined"}>{this.props.children}</LoadingDots>;
	}
}

Auth.propTypes = {
	authAction: PropTypes.func.isRequired,
	loaders: PropTypes.shape({}).isRequired,
};

function mapStateToProps(state) {
	return {
		loaders: state.forms.loaders,
	};
}

const mapDispatchToProps = {
	authAction: auth,
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
